import { RefreshCw } from "lucide-react";

import { refreshToLatest, useUpdateAvailable } from "./updateAvailable";

/**
 * Compact "Update" pill for the app header. Renders nothing unless a newer
 * build is pending. Pulses once on appearance (`motion-safe:` so reduced-motion
 * users get none); label collapses to the icon on the narrow side panel.
 */
export function UpdatePill() {
  const latest = useUpdateAvailable();
  if (!latest) return null;
  return (
    <button
      type="button"
      onClick={() => refreshToLatest(latest)}
      aria-label="Update available, refresh"
      title="A new version is available. Refresh to update."
      className="motion-safe:animate-[pulse_1s_ease-in-out_2] inline-flex h-8 shrink-0 items-center gap-1.5 rounded-full bg-primary/10 px-2.5 text-xs font-medium text-primary hover:bg-primary/20 focus:outline-none focus-visible:ring-2 focus-visible:ring-ring transition-colors"
    >
      <RefreshCw size={14} aria-hidden="true" />
      <span className="app-header-collapsible-label">Update</span>
    </button>
  );
}

/** Top item for the account menu; null (so the menu adds no separator) when up to date. */
export function UpdateMenuItem() {
  const latest = useUpdateAvailable();
  if (!latest) return null;
  return (
    <button
      type="button"
      onClick={() => refreshToLatest(latest)}
      className="flex w-full items-center gap-2 px-3 py-2 text-left text-sm font-medium text-primary hover:bg-accent focus:outline-none focus-visible:ring-2 focus-visible:ring-ring"
    >
      <RefreshCw size={14} aria-hidden="true" />
      Update available, refresh
    </button>
  );
}
